/**
 * @generated SignedSource<<aa7d16570907a12d91ac29361664d7c4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutReturningBuyerDeliveryOptionsView_preCheckoutTransaction$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutDeliveryOptions_preCheckoutTransaction">;
  readonly " $fragmentType": "CheckoutReturningBuyerDeliveryOptionsView_preCheckoutTransaction";
};
export type CheckoutReturningBuyerDeliveryOptionsView_preCheckoutTransaction$key = {
  readonly " $data"?: CheckoutReturningBuyerDeliveryOptionsView_preCheckoutTransaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutReturningBuyerDeliveryOptionsView_preCheckoutTransaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutReturningBuyerDeliveryOptionsView_preCheckoutTransaction",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutDeliveryOptions_preCheckoutTransaction"
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "354208b9b8f77e77031f2ba1356a202e";

export default node;
